
// eslint-disable-next-line @typescript-eslint/ban-ts-ignore
// @ts-ignore
import VBtnToggle from 'vuetify/lib/components/VBtnToggle/VBtnToggle';
import Vue from 'vue';

const base = Vue.extend({ mixins: [VBtnToggle] });
export default base.extend({
    name: 'base-button-group',
    computed: {
        // add our CSS classes to the default vuetify classes
        classes(): object {
            return {
                ...VBtnToggle.options.computed.classes.call(this),
                'base-button-group': true
            };
        }
    }
});
